import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useChargebeePortals } from "hooks/useChargebeePortals";


export function AutoOpenPaymentMethodDialog() {
  const { openChargebeePortal } = useChargebeePortals();
  const navigate = useNavigate();

  useEffect(() => {
    openChargebeePortal("PAYMENT_SOURCES", { close: () => navigate("/billing") });
  }, [ openChargebeePortal, navigate ]);

  return <></>;
}
